function posFeatureBarTab(integrationConstant, integrationSettingsService, integrationViewService,
                          gettextCatalog) {
    const vm = this;
    const manageDisplay = () => {
        // Integration type(pos,fulfilment)
        const parentComponentRules = vm.mapVisibleFeature;
        const actions = {
            barTab: vm.data.barTab
        };
        const externalImpact = {
            parentComponentRules,
            siblingsComponent: actions,
            parentData: vm.parentData || null,
            isUseMerchantSettings: vm.data.isUseMerchantSettings
        };
        vm.visible = integrationViewService.getBarTabDisplay(externalImpact);
    };
    const commonUpdate = () => {
        vm.onDataUpdate({updatedData: vm.data});
        manageDisplay();
    };
    const manageInitialState = () => {
        vm.initialStateData = {toggle: vm.data.barTab, posType: vm.data.posType};
    };
    vm.updateToggleBarTab = () => {
        commonUpdate();
        vm.toggleSet.barTab = vm.data.barTab;
        vm.onToggleUpdate({toggleSet: vm.toggleSet});
        manageInitialState();
        // need to be after onDataUpdate
        vm.onToggleCleanSubFeature({data : {value: vm.data.barTab, type: 'bar'}});
    };
    vm.updateBarTab = () => {
        commonUpdate();
    };
    vm.$onInit = () => {
        vm.RADIO_YES = integrationConstant.VIEW_SETTINGS.RADIO_YES;
        vm.RADIO_NO = integrationConstant.VIEW_SETTINGS.RADIO_NO;
        vm.FEATURES = {
            barTab: {
                label: gettextCatalog.getString('Bar Tab')
            }
        };
        vm.data = integrationSettingsService.merge({}, vm.integrationData);
        manageInitialState();
        commonUpdate();
    };
    vm.$onChanges = (changesObj) => {
        // Changes in the integrationData on the parent needs to be update
        if (changesObj.integrationData) {
            vm.data = integrationSettingsService.merge({}, changesObj.integrationData.currentValue);
            manageDisplay();
            manageInitialState();
        }
        if (changesObj.mapVisibleFeature) {
            vm.mapVisibleFeature = changesObj.mapVisibleFeature.currentValue;
            manageDisplay();
            manageInitialState();
        }
    };
}
angular.module('qkr.integration.settings')
    .component('barTab', {
        template: require('./bar-tab.html'),
        bindings: {
            integrationData: '<',
            parentData: '<?',
            integrationForm: '<',
            mapVisibleFeature: '<',
            toggleSet: '<',
            location: '<',
            onDataUpdate: '&',
            onToggleUpdate: '&',
            onToggleCleanSubFeature: '&'
        },
        controller: posFeatureBarTab,
        controllerAs: 'vm'
    });




// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/pos-feature/bar.tab.component.js